import type { ReactNode } from 'react';

import styles from './Callout.module.css';

export interface CalloutProps {
  tone?: 'info' | 'danger';
  title?: string;
  children: ReactNode;
}

export function Callout({ tone = 'info', title, children }: CalloutProps) {
  return (
    <div
      className={`${styles.callout} ${styles[tone]}`}
      role={tone === 'danger' ? 'alert' : undefined}
    >
      <span className={styles.glyph} aria-hidden="true">
        {tone === 'danger' ? '!' : 'i'}
      </span>
      <div className={styles.text}>
        {title ? <strong className={styles.title}>{title}</strong> : null}
        <div>{children}</div>
      </div>
    </div>
  );
}
